import { render } from "./AutreServicePage.vue?vue&type=template&id=3c53c151"
import script from "./AutreServicePage.vue?vue&type=script&lang=js"
export * from "./AutreServicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__